import { z } from "zod";
import type { AtomOfThought, Journey } from "./journey";
import type { Quest } from "./quest";

export type JourneyQuest = {
  id: string;
  sortOrder: number;
  questId: string;
  journeyId: string;
};

export type JourneyQuestCreate = {
  questId: string;
  journeyId: string;
  sortOrder: number;
};

export const journeyQuestCreateSchema = z.object({
  questId: z.string(),
  journeyId: z.string(),
  sortOrder: z.number(),
}) satisfies z.ZodType<JourneyQuestCreate>;

export type JourneyQuestUpdate = {
  id: string;
  sortOrder: number;
};

export const journeyQuestUpdateSchema = z.object({
  id: z.string(),
  sortOrder: z.number(),
}) satisfies z.ZodType<JourneyQuestUpdate>;

export type JourneyQuestWithQuest = JourneyQuest & {
  quest: Quest;
};

export type JourneyWithQuests = Journey & {
  journeyQuests: JourneyQuestWithQuest[];
  atomsOfThought: AtomOfThought[];
};
